export let initialState = {
        fonts:{
            size:{},
            family:{}
        },
        header:{
            menu:[],
            jumboText:{
                quote:{
                    header:'',
                    author:'',
                    PolishLang:{
                        header:''
                    }
                },
                a:{
                    header:'',
                    href:'',
                    PolishLang:{
                        header:''
                    }
                }
            },
        },
        aboutIntro:{
            header:'',
            text:'',
            PolLang:{
                header:'',
                text:''
            }
        },
        stack:{
            header:'',
            tools:[]
        },
        projects:[],
        reactInfo:{},
        footer:{
            rightData:[]
        },
        buttons:{
            github:{
                eng:'',
                pl:''
            }
        },
    }